import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import InputMask from "../../../../components/hookForms/inputMask";
import InputNumber from "../../../../components/hookForms/inputNumber";
import InputPersonSearch from "../../../../components/inputPersonSearch";
import InputText from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceLancamentoManual from "../../../../services/serviceLancamentoManual";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

const schema = yup.object().shape({
    numeroInstalacao: yup.string().required(messages.requiredField),
    categoriaLancamento: yup.string().required(messages.requiredField),
    motivoLancamentoManualID: yup.string().required(messages.requiredField),
    tipoValorLancamento: yup.string().required(messages.requiredField),
    valorLancamentoManual: yup.string().required(messages.requiredField),
    descricao: yup.string().required(messages.requiredField),
});

export default function DialogNew({ open, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [motivoDataOptions, setMotivoDataOptions] = useState<IGenericResult[]>([]);
    const [categoria, setCategoria] = useState("");

    const [newClienteInstalacao, setNewClienteInstalacao] = useState({
        nomeCliente: "",
        clienteID: 0,
        instalacaoID: 0,
        numeroInstalacao: "",
        clienteInstalacaoID: "",
    });

    const [searchClient, setSearchClient] = useState({
        open: false,
        nomeCliente: "",
        instalacaoID: 0,
        numeroInstalacao: "",
        clienteInstalacaoID: "",
    });

    useEffect(() => {
        reset({ numeroInstalacao: newClienteInstalacao.numeroInstalacao });
    }, [newClienteInstalacao]);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            numeroInstalacao: "",
            clienteInstalacaoID: "",
            categoriaLancamento: "",
            motivoLancamentoManualID: "",
            tipoValorLancamento: "",
            valorLancamentoManual: "",
            cicloFaturamentoDe: "",
            cicloFaturamentoAte: "",
            descricao: "",
        },
    });

    const categoriaOptions = [
        { label: "Dedução", value: "Dedução" },
        { label: "Acréscimo", value: "Acréscimo" },
    ];

    const tipoOptions = [
        { label: "kWh", value: "KWH" },
        { label: "Dinheiro", value: "Dinheiro" },
    ];

    useEffect(() => {
        if (open) {
            if (!categoria) return;
            setMotivoData();
        }
    }, [categoria]);

    const setMotivoData = async () => {
        serviceLancamentoManual
            .getMotivosByCategoria({ categoria })
            .then((result) => {
                setMotivoDataOptions(result?.data);
            })
            .catch((err) => {
                setMotivoDataOptions([]);
            });
    };

    const onCancelNew = () => {
        reset({ numeroInstalacao: "" });
        reset();
        onClose(true);
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        if (values) {
            const newItem = {
                ...values,
                clienteInstalacaoID: newClienteInstalacao.clienteInstalacaoID,
                valorLancamentoManual: values.valorLancamentoManual
                    ? Number(values.valorLancamentoManual.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                cicloFaturamentoDe: values.cicloFaturamentoDe ? values?.cicloFaturamentoDe : "",
                cicloFaturamentoAte: values.cicloFaturamentoAte ? values?.cicloFaturamentoAte : "",
                statusLancamentoManual: "Não Usado",
            };

            serviceLancamentoManual
                .create(newItem)
                .then((result) => {
                    if (result) {
                        toast.success(messages.createSucess);
                        onClose(true);
                        reset();
                        onSuccess();
                    }
                })
                .catch((err) => {
                    toast.error(messages.createError, err);
                })
                .finally(() => {
                    setDisable(false);
                });
        } else {
            setDisable(false);
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                    reset();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Novo lançamento manual
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelNew();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <InputText
                                id="numeroInstalacao"
                                name="numeroInstalacao"
                                label="Instalação"
                                control={control}
                                error={errors}
                                onClick={() => {
                                    setSearchClient({
                                        open: true,
                                        nomeCliente: "",
                                        instalacaoID: Number(0),
                                        numeroInstalacao: "",
                                        clienteInstalacaoID: "",
                                    });
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                id="categoriaLancamento"
                                name="categoriaLancamento"
                                label="Categoria"
                                onChange={(value) => setCategoria(value.toString())}
                                options={categoriaOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                id="motivoLancamento"
                                name="motivoLancamentoManualID"
                                label="Motivo"
                                options={motivoDataOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <AutoComplete
                                id="tipoValorLancamento"
                                name="tipoValorLancamento"
                                label="Tipo"
                                options={tipoOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                id="valorLancamentoManual"
                                name="valorLancamentoManual"
                                label="Valor"
                                control={control}
                                error={errors}
                                decimalScale={2}
                                maxLength={12}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputMask
                                id="cicloFaturamentoDe"
                                name="cicloFaturamentoDe"
                                label="Ciclo - De"
                                mask="99/9999"
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputMask
                                id="cicloFaturamentoAte"
                                name="cicloFaturamentoAte"
                                label="Ciclo - Até"
                                mask="99/9999"
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <InputText
                                id="descricao"
                                name="descricao"
                                label="Descrição"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => {
                            onCancelNew();
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>

            <InputPersonSearch
                returnData={(item: any) => {
                    setNewClienteInstalacao(item);
                }}
                data={{
                    open: searchClient.open,
                    nomeCliente: searchClient.nomeCliente,
                    instalacaoID: searchClient.instalacaoID,
                    numeroInstalacao: searchClient.numeroInstalacao,
                }}
                onClose={() =>
                    setSearchClient({
                        open: false,
                        nomeCliente: "",
                        instalacaoID: 0,
                        numeroInstalacao: "",
                        clienteInstalacaoID: "",
                    })
                }
            />
        </Dialog>
    );
}
